import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withCookies, Cookies } from 'react-cookie';

import { checkAuthFull } from 'cityads-v3/actions/auth';

export class AuthChecker extends PureComponent {
  static propTypes = {
    dispatch                  : PropTypes.func.isRequired,
    checkingAuth              : PropTypes.bool.isRequired,
    isAuthChecked             : PropTypes.bool.isRequired,
    cookies                   : PropTypes.instanceOf(Cookies).isRequired,
    needSadukaAuthUpdate      : PropTypes.number,
    isStorageCookieChecked    : PropTypes.bool,
    isStorageCookieRequesting : PropTypes.bool,
    storageCookie             : PropTypes.string,
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.needSadukaAuthUpdate !== this.props.needSadukaAuthUpdate) {
      this.checkAuthFull().then(() => {
        window.location.reload();
      })
    }
  }

  componentDidMount() {
    if (!this.props.isAuthChecked || !this.props.isStorageCookieChecked) {
      this.checkAuthFull();
    }
  }

  checkAuthFull() {
    const { dispatch, cookies } = this.props;

    return dispatch(checkAuthFull({ cookies: cookies || this.props.storageCookie }))
      .catch(() => console.warn('Not logged in'))
    ;
  }

  render() {
    return null;
  }
}

export default compose(
  withCookies,
  connect(
    state => ({
      checkingAuth: state.auth.checkingAuth,
      isAuthChecked: state.auth.isAuthChecked,
      needSadukaAuthUpdate: state.auth.needSadukaAuthUpdate,
      isStorageCookieChecked: state.auth.isStorageCookieChecked,
      isStorageCookieRequesting: state.auth.isStorageCookieRequesting,
      storageCookie: state.auth.cookie
    })
  )
)(AuthChecker);
